
import { defineComponent, PropType } from 'vue'

// @types
import { InventoryTotalsTMS } from '@/new-services/types/tms'

export default defineComponent({
    props: {
        totals: {
            type: Object as PropType<InventoryTotalsTMS>,
            default: null,
        },
        column: {
            type: Object as PropType<any>,
            default: null,
        },
    },
})
